module.exports = __webpack_public_path__ + "img/logoText.1bf790bd.png";